import AppInput from '../core/outlinedInput';
import { styled } from '@material-ui/core';

const ShortInput = styled(AppInput)({
  maxWidth: 175,
  flex: 2,
});

export default ShortInput;
